export default __webpack_public_path__ + "static/media/art-sm-square.67d90202.jpg";